<main class="table-page table-page--fill vazir" dir="rtl">
  <header class="header"><div class="title-row">
    <button class="back" type="button" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
    <div class="title-block"><h1 class="title">{{ definition.title }}</h1><span class="muted">{{ subtitle | faNum }}</span></div>
    <div class="actions"><button class="btn btn-ghost" type="button" [disabled]="loading || hasError || !rows.length" (click)="resetZoom()"><i class="fa fa-undo"></i> حالت عادی</button></div>
  </div></header>
  <section class="card" [class.d-none]="!hasMap || loading || hasError || !rows.length" aria-label="موقعیت نقطهٔ نمودار">
    <div class="body" #mapTarget></div>
  </section>
  <section class="card">
    <div class="body">
      <div class="loader" [class.show]="loading" role="status" aria-live="polite"><div class="spinner"></div><span>در حال دریافت اطلاعات…</span></div>
      <div class="state" [class.show]="!loading && !hasError && !rows.length"><div class="ico-big"><i class="fa fa-inbox"></i></div><h4>اطلاعاتی برای این بازهٔ تاریخ وجود ندارد</h4></div>
      <div class="state error" [class.show]="!loading && hasError"><div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div><h4>دریافت اطلاعات با خطا مواجه شد</h4><span class="muted">{{ errorMessage }}</span>
        <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="loadReport()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
      </div>
      <div class="body" [class.d-none]="loading || hasError || !rows.length"><canvas #canvas role="img" [attr.aria-label]="definition.title"></canvas></div>
    </div>
  </section>
</main>
